import { createFileRoute } from '@tanstack/react-router';
import { WebhookHealthPanel } from '../../components/WebhookHealthPanel';

function FacebookWebhookHealthPage() {
  return (
    <WebhookHealthPanel
      object="page"
      title="Facebook (Messenger) webhook health"
      objectLabel="page"
      productNoun="Messenger"
    />
  );
}

export const Route = createFileRoute('/central/facebook-webhook-health')({
  component: FacebookWebhookHealthPage,
});
